import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { MdDelete } from "react-icons/md";
import { BsEyeFill } from "react-icons/bs";
import { TbEdit } from "react-icons/tb";
import { BsPrinterFill } from "react-icons/bs";
import { IoMdPrint } from "react-icons/io";
//Srcs
import "../../Style/actionstyle.scss";
import UpdateStudentBook from "./UpdateStudentBook";
import ViewStudentBook from "./ViewStudentBook";
import Delete from "../Include/Delete";
import { DELETE_STUDENT_BOOK } from "../../Schema/StudentBook";
import { AuthContext } from "../../Context/AuthContext";

export default function StudentBookAction({ editData, setRefetch }) {
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal delete
  const [openView, setOpenView] = useState(false);
  const handleOpenView = () => setOpenView(true);
  const handleCloseView = () => setOpenView(false);

  const [deleteStudentBook] = useMutation(DELETE_STUDENT_BOOK, {
    onCompleted: ({ deleteStudentBook }) => {
      setLoading(false);
      if (deleteStudentBook?.status === true) {
        setAlert(true, "success", deleteStudentBook?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteStudentBook?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteStudentBook({
      variables: {
        id: editData?._id,
      },
    });
  };

  // console.log("Row::::", editData);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="ព្រីន" placement="top">
          <IconButton onClick={handleOpenView}>
            <Box
              className="update-container"
              sx={{ border: "1px solid #4caf50 !important" }}
            >
              <IoMdPrint style={{ fontSize: "18px", color: "#4caf50" }} />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {
        openEdit &&
          <UpdateStudentBook
            handleClose={handleCloseEdit}
            setRefetch={setRefetch}
            editData={editData}
            open={openEdit}
          />
      }
      
      {
        openView && 
          <ViewStudentBook
            open={openView}
            handleClose={handleCloseView}
            editData={editData}
          />
      }
      
      {
        openDel && 
        <Delete
          open={openDel}
          handleClose={handleCloseDel}
          title={"StudentBook"}
          loading={loading}
          handleDelete={handleDelete}
        />
      }
      
    </div>
  );
}
